import "./SuvaiMenu.scss"
import menu from "../../assets/images/menu.jpg"
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import { LOCAL_STORAGE_ITEMS_NAMES } from "../../../../../utilities/helper";
import { fetchAllRestaurantMenuData, getAllData, getAvailableMenuItems, getAvailableMenus } from "../../../../../../../redux/resturantWidgetSlice";
import MenuItem from "../../components/MenuItem/MenuItem";
import Button from "../../components/button/Button";
import { sortByOrderAscending } from "../../helper/helper";
const SuvaiMenu = () => {
    const company = useSelector((state) => state.companyData.company);
    const { menuData, defualtSelectedLocation, organizationID, } = useSelector((state) => state.resturantData);
    const [data, setData] = useState(null)
    const [itemsData, setItemsData] = useState(data)
    const [isLoading, setIsLoading] = useState(false)
    const [categories, setCategories] = useState([])
    const dispatch = useDispatch()
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const fetchMenuData = useCallback(() => {
        const userId = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID);

        dispatch(fetchAllRestaurantMenuData({
            CloudLocationID: company?.LocationID,
            OrganizationID: company?.OrganisationID,
            UserID: localStorage.getItem('isLogged') && localStorage.getItem('isLogged') === 'true' ? userId : "",
            Type: "MENU"
        }));

    }, [dispatch, defualtSelectedLocation, organizationID]);


    useEffect(() => {
        setIsLoading(true)
        fetchMenuData();

    }, []);
    useEffect(() => {
        getAllData().then((result) => {
            setData(result);

        });
    }, [menuData]);
    useEffect(() => {
        if (data) {
            const menuDataObject = data
            let filteredCategories = getAvailableMenus(
                menuDataObject.data.Menu,
                menuDataObject.data.Categories
            )
            let filteredItems = getAvailableMenuItems(
                menuDataObject.data.Items,
                filteredCategories
            )
            const updatedData = {
                ...menuDataObject.data,
                Categories: filteredCategories,
                Items: filteredItems
            };
            setCategories(filteredCategories);
            setItemsData(updatedData);
            setIsLoading(false)
        }

    }, [isLoading, data]);
    const getCatgoryItems = (menuEntities) => {
        if (!menuEntities || !Array.isArray(menuEntities) || !itemsData?.Items) return [];
        const menuItemIDs = menuEntities.flatMap(entity => entity.ID);
        const items = itemsData.Items.filter(item => menuItemIDs.includes(item.MenuItemID));

        return items;
    }
    const Components = [
        {
            "ID": "SuvaiMenu-hero",
            "Order": 1,
            "Type": "content",
            "Props": null,
            "Components": [
                {
                    "ID": "SuvaiMenu-hero-ImageContainer",
                    "Order": 1,
                    "Type": "content",
                    "Props": {
                        "bgSrc": menu,
                        "text": " The suvai fusion experience"
                    }
                },
                {
                    "ID": "SuvaiMenu-hero-TextContainer",
                    "Order": 2,
                    "Type": "content",
                    "Props": null,
                    "Components": [
                        {
                            "ID": "SuvaiMenu-hero-textCont-subheader",
                            "Order": 1,
                            "Type": "text",
                            "Props": {
                                "text": "a la carte"
                            }
                        },
                        {
                            "ID": "SuvaiMenu-hero-textCont-header",
                            "Order": 2,
                            "Type": "text",
                            "Props": {
                                "text": "Menu"
                            }
                        },
                        {
                            "ID": "SuvaiMenu-hero-textCont-content",
                            "Order": 3,
                            "Type": "text",
                            "Props": {
                                "text": "We are passionate about sourcing fresh ingredients, combining with traditional flavours and continually evolving our menu to create a dining experience that is truly unique."
                            },
                        }


                    ]
                }


            ]
        },
        {
            "ID": "SuvaiMenu-container",
            "Order": 2,
            "Type": "",
            "Props": null,
            "Components": [
                {
                    "ID": "SuvaiMenu-menu",
                    "Order": 1,
                    "Type": "",
                    "Props": null,
                },
                {
                    "ID": "SuvaiMenu-menuBtn",
                    "Order": 2,
                    "Type": "",
                    "Props": {
                        "href": "",
                        "text": "Order Now",
                        "type": "SECONDARY"
                    },
                }
            ]
        },
        {
            "ID": "SuvaiHome-MobileFixed",
            "Order": 3,
            "Type": "",
            "Props": null,
            "Components": [
                {
                    "ID": "SuvaiHome-MobileFixed-button",
                    "Order": 1,
                    "Type": "button",
                    "Props": {
                        "href": "",
                        "btnText": "Order Now",
                        "padding": "14px 0px",
                        "width": "100%",
                        "type": "PRIMARY"
                    }
                },
                {
                    "ID": "SuvaiHome-MobileFixed-button",
                    "Order": 2,
                    "Type": "button",
                    "Props": {
                        "href": "",
                        "btnText": "Book a table",
                        "padding": "14px 0px",
                        "width": "100%",
                        "type": "SECONDARY"
                    }
                }
            ]
        }
    ]
    const getMenuComponents = (component) => {
        switch (component.ID) {
            case "SuvaiMenu-menu":
                return <div className="SuvaiMenu-container-inner-menu">

                    {categories?.map((category) => {
                        return (
                            <MenuItem
                                items={
                                    getCatgoryItems(category.MenuEntities)
                                }
                                headerText={category?.Title?.en}
                            />)
                    })}</div>
            case "SuvaiMenu-menuBtn":
                return <Button
                    text={component?.Props?.text}
                    type={component?.Props?.type}
                    onClick={() => {
                        window.open(component?.Props?.href, '_blank')
                    }} />
            default:
                return <div />
        }

    }
    const getMenuContent = (components) => {
        return (
            <div className="SuvaiMenu-container">
                <div className="SuvaiMenu-container-inner">
                    {sortByOrderAscending(components).map((component, key) => {
                        return getMenuComponents(component)
                    })}
                </div>
            </div>
        )
    }
    const getHeroImageContent = (props) => {
        return (
            <div className="SuvaiMenu-hero-imageCont"
                style={{
                    backgroundImage: `linear-gradient(0deg, rgba(42, 42, 43, 0.18), rgba(42, 42, 43, 0.18)),
linear-gradient(180deg, rgba(16, 18, 19, 0) 0%, rgba(16, 18, 19, 0.6) 40%, rgba(16, 18, 19, 0.6) 60%, rgba(16, 18, 19, 0) 100%) , url(${props.bgSrc})`
                }}>
                <div className="SuvaiMenu-hero-imageCont-header">
                    {props?.text}
                </div>
            </div>
        )
    }
    const getHeroTextContent = (component) => {
        switch (component.ID) {
            case "SuvaiMenu-hero-textCont-subheader":
                return <div className="SuvaiMenu-hero-textCont-subheader">{component?.Props?.text}</div>

            case "SuvaiMenu-hero-textCont-header":
                return <div className="SuvaiMenu-hero-textCont-header">{component?.Props?.text}</div>
            case "SuvaiMenu-hero-textCont-content":
                return <div className="SuvaiMenu-hero-textCont-content">{component?.Props?.text}</div>

            default:
                return <div />
        }

    }
    const getHeroTextComponent = (components) => {
        return (
            <div className="SuvaiMenu-hero-textCont">
                {sortByOrderAscending(components).map((component, key) => {
                    return getHeroTextContent(component)
                })}
            </div>

        )
    }
    const getHeroComponents = (component) => {
        switch (component.ID) {
            case "SuvaiMenu-hero-ImageContainer":
                return getHeroImageContent(component.Props)
            case "SuvaiMenu-hero-TextContainer":
                return getHeroTextComponent(component.Components)
            default:
                return <div />
        }

    }
    const getHeroContent = (components) => {
        return (
            <div className="SuvaiMenu-hero">
                {sortByOrderAscending(components).map((component, key) => {
                    return getHeroComponents(component)
                })}
            </div>
        )
    }
    const getcomponentFixedContainerComponents = (component) => {
        switch (component.ID) {
            case "SuvaiHome-MobileFixed-button":
                return <Button
                    text={component?.Props.btnText}
                    padding={component?.Props?.padding}
                    width={component?.Props.width}
                    type={component?.Props.type}
                    onClick={() => {
                        if (component?.Props?.href && component?.Props?.href !== "") {
                            window.open(component?.Props?.href, '_blank')
                        }
                    }} />
            default:
                return <div />
        }

    }
    const getcomponentFixedContainer = (components) => {
        return (<div className="SuvaiHome-MobileFixed">
            {sortByOrderAscending(components).map((component, key) => {
                return getcomponentFixedContainerComponents(component)
            })}
        </div>)
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "SuvaiMenu-hero":
                return getHeroContent(component.Components)
            case "SuvaiMenu-container":
                return getMenuContent(component.Components)
            case "SuvaiHome-MobileFixed":
                return getcomponentFixedContainer(component?.Components)

            default:
                return <div />
        }

    }
    return (
        <div className="SuvaiMenu">
            {sortByOrderAscending(Components).map((component, key) => {
                return getComponents(component)
            })}
        </div>
    )
}
export default SuvaiMenu
